import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { ToastrService } from 'ngx-toastr';
// declare var $: any
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {
  @ViewChild('addroleform') public addroleform: NgForm
  model: any={name:'',description:''};
  id: any;
  opt: any;
  applicationLists: any = [];
  application: any = [];
  buttonTitle: String = '';
  title: String = '';
  app_id: any;
  user_id: any;
  username: any;
  isAdmin: any;
  application_name:any;
  isLoading:boolean
  isSavingData:boolean=false
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private accesscontrolService: AccessControlService,
    private checkPermissionService: CheckPermissionService,
    private toastrService: ToastrService) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt');

    if (this.opt == 'add') {
      this.app_id = this.activatedRoute.snapshot.queryParamMap.get('app_id')
      this.buttonTitle="Save"
    }
    else {
      this.app_id = this.activatedRoute.snapshot.params['app_id'];
      this.buttonTitle="Update"
    }
  }

  ngOnInit() {
    this.username = localStorage.getItem('username');
    this.user_id = localStorage.getItem('user_id');
    this.activatedRoute.queryParamMap.subscribe((param:any)=>{
      this.application_name=param.params.appname||""
    })
    this.checkIfAdminIsChecked();
    if (this.opt == 'add') {
      this.buttonTitle = 'Save'
      this.title = 'Add Role'
    }
    else {
      this.buttonTitle = 'Update'
      this.title = 'Edit Role'
      this.getrolebyId()
    }
    // this.getapplicationbyId();
  }
  submit() {
    if (!this.addroleform.valid) {
      return
    }
    this.model.name=this.model.name.toUpperCase();
    if (this.opt == 'add') {
      this.AddRole();
    }
    else {
      this.updateUser();
    }
  }
  getapplicationbyId() {
    this.accesscontrolService.getapplicationbyId(this.app_id).subscribe((res) => {
      this.application = res;
      this.model.application_id = this.app_id
      this.model.application_code = this.application.application_code;
      this.model.application_name = this.application.application_name;
    }, error => {
      console.log(error)
    },
      () => {

      })
  }
  // listallapplications() {
  //   this.accesscontrolService.listallapplications().subscribe((res) => {
  //     this.applicationLists = res;
  //   }, error => {

  //   }, () => {
  //   })
  // }
  // selected_application(application_id: any) {
  //   this.accesscontrolService.getapplicationbyId(application_id).subscribe((res) => {
  //     this.application = res;
  //     this.model.application_id = application_id
  //     this.model.application_code = this.application.application_code;
  //     this.model.application_name = this.application.application_name;
  //   }, error => {
  //     console.log(error)
  //   },
  //     () => {

  //     })
  // }
  //registenr User
  AddRole() {
    this.model.modified_by = this.user_id;
    this.model.modified_by_name = this.username;
    this.model.created_by = localStorage.getItem('username')
    this.model.application_id=this.app_id;
    this.model.application_name=this.application_name;
    this.model.orgId=localStorage.getItem("org_id");
    this.isSavingData=true
    this.authService.AddRole(this.model).subscribe((res) => {
    }, error => {
      this.isSavingData=false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastrService.error(errorMessage)
    }, () => {
      this.isSavingData=false
      this.toastrService.success("Role Added Successfully");
      this.router.navigate(['/role-listing/' + this.app_id],{queryParams:{appname:this.application_name}})
    })
  }
  getrolebyId() {
    this.isLoading=true
    this.authService.getrolebyId(this.id).subscribe((res) => {
      this.model = res;
      this.isLoading=false
    }, error => {
      this.isLoading=false
      console.log(error)
    },
    () => {})
  }
  updateUser() {
    this.model.modified_by = this.user_id;
    this.model.modified_by_name = this.username;
    this.model.application_id=this.app_id;
    this.model.orgId=localStorage.getItem("org_id");
    this.isSavingData=true
    this.authService.updateRole(this.model).subscribe((res) => {
      this.model = res
    }, error => {
      this.isSavingData=false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastrService.error(errorMessage)
    }, () => {
      this.isSavingData=false
      this.toastrService.success("Role Updated Successfully");
      this.router.navigate(['/role-listing/' + this.app_id],{queryParams:{appname:this.application_name}});
    })
  }
  checkIfAdminIsChecked() {
    let clientId=localStorage.getItem("org_id");
    this.accesscontrolService.isAnyAdmin(this.app_id,clientId).subscribe((res: any) => {
      if (res._id && res._id == this.id) {
        this.isAdmin = false;
        this.model.isAdmin = true;
      }
      else if (res._id) {
        this.isAdmin = true;
      }
      else
        this.isAdmin = false;
    })
  }
}

